export enum DataProductApi {
  DATA_PLANE_API = 'DATA_PLANE_API',
  CONTROL_PLANE_DATA_PRODUCT_API = 'CONTROL_PLANE_DATA_PRODUCT_API',
  CURATED_API = 'CURATED_API',
}

export const DATA_PRODUCT_NAMES: Record<DataProductApi, string> = {
  [DataProductApi.DATA_PLANE_API]: 'Data Plane Data Product',
  [DataProductApi.CONTROL_PLANE_DATA_PRODUCT_API]: 'Control Plane Data Product',
  [DataProductApi.CURATED_API]: 'Curated GraphQL API',
} as const;
